import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center px-6">
      <div className="max-w-md text-center space-y-4">
        <p className="text-sm uppercase tracking-widest text-zinc-500">404</p>
        <h1 className="text-3xl font-bold">Page not found</h1>
        <p className="text-sm text-zinc-400">The page you requested does not exist or was moved.</p>
        <Link to="/" className="inline-flex rounded-full bg-white text-black px-5 py-2 text-sm font-semibold">
          Go home
        </Link>
      </div>
    </div>
  );
}
